"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// MIT © 2017 azu
var RepositoryCore_1 = require("./RepositoryCore");
var map_like_1 = require("map-like");
/**
 * NonNullableRepository has initial value.
 * In other words, NonNullableRepository#get always return a value.
 */
var NonNullableRepository = /** @class */ (function () {
    function NonNullableRepository(initialEntity) {
        this.initialEntity = initialEntity;
        this.core = new RepositoryCore_1.RepositoryCore(new map_like_1.MapLike());
    }
    Object.defineProperty(NonNullableRepository.prototype, "map", {
        get: function () {
            return this.core.map;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NonNullableRepository.prototype, "events", {
        get: function () {
            return this.core.events;
        },
        enumerable: true,
        configurable: true
    });
    NonNullableRepository.prototype.get = function () {
        return this.core.getLastSaved() || this.initialEntity;
    };
    NonNullableRepository.prototype.getAll = function () {
        return this.core.getAll();
    };
    NonNullableRepository.prototype.findById = function (entityId) {
        return this.core.findById(entityId);
    };
    NonNullableRepository.prototype.save = function (entity) {
        this.core.save(entity);
    };
    NonNullableRepository.prototype.delete = function (entity) {
        this.core.delete(entity);
    };
    NonNullableRepository.prototype.clear = function () {
        this.core.clear();
    };
    return NonNullableRepository;
}());
exports.NonNullableRepository = NonNullableRepository;
//# sourceMappingURL=NonNullableRepository.js.map